export function fileToLineArt(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const W = 800;
      const H = 1000;
      const c = document.createElement("canvas");
      c.width = W;
      c.height = H;
      const ctx = c.getContext("2d");
      ctx.fillStyle = "#FFFDF8";
      ctx.fillRect(0, 0, W, H);
      const r = Math.min(W / img.width, H / img.height);
      const w = img.width * r;
      const h = img.height * r;
      ctx.drawImage(img, (W - w) / 2, (H - h) / 2, w, h);
      URL.revokeObjectURL(url);

      const src = ctx.getImageData(0, 0, W, H);
      const gray = new Float32Array(W * H);
      for (let i = 0; i < W * H; i++) {
        const j = i * 4;
        gray[i] = 0.299 * src.data[j] + 0.587 * src.data[j + 1] + 0.114 * src.data[j + 2];
      }

      const edges = new Float32Array(W * H);
      for (let y = 1; y < H - 1; y++) {
        for (let x = 1; x < W - 1; x++) {
          const i = y * W + x;
          const tl = gray[i - W - 1], t = gray[i - W], tr = gray[i - W + 1];
          const l = gray[i - 1], rr = gray[i + 1];
          const bl = gray[i + W - 1], b = gray[i + W], br = gray[i + W + 1];
          const gx = -tl - 2 * l - bl + tr + 2 * rr + br;
          const gy = -tl - 2 * t - tr + bl + 2 * b + br;
          edges[i] = Math.sqrt(gx * gx + gy * gy);
        }
      }

      const out = ctx.createImageData(W, H);
      const TH = 95;
      for (let i = 0; i < W * H; i++) {
        const j = i * 4;
        const v = edges[i] > TH ? 26 : 255;
        out.data[j] = v;
        out.data[j + 1] = v;
        out.data[j + 2] = v;
        out.data[j + 3] = 255;
      }

      const dil = ctx.createImageData(W, H);
      dil.data.set(out.data);
      for (let y = 1; y < H - 1; y++) {
        for (let x = 1; x < W - 1; x++) {
          const i = y * W + x;
          if (out.data[i * 4] === 255) {
            if (
              out.data[(i - 1) * 4] < 128 ||
              out.data[(i + 1) * 4] < 128 ||
              out.data[(i - W) * 4] < 128 ||
              out.data[(i + W) * 4] < 128
            ) {
              dil.data[i * 4] = 26;
              dil.data[i * 4 + 1] = 26;
              dil.data[i * 4 + 2] = 26;
            }
          }
        }
      }

      ctx.putImageData(dil, 0, 0);
      resolve(c.toDataURL("image/jpeg", 0.92));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("bad image"));
    };
    img.src = url;
  });
}
